// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PostAudio_postContainer__-H-t9 {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  direction: rtl;
  background: linear-gradient(135deg, #f8fffe 0%, #f0f9f7 100%);
  min-height: fit-content;
}

.PostAudio_postWrapper__Mes9l {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  margin-bottom: 40px;
}

/* Breadcrumb Navigation */
.PostAudio_breadcrumb__4FUEW {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 30px;
  font-size: 14px;
  color: #64748b;
  flex-wrap: wrap;
}

.PostAudio_breadcrumbLink__mUtw3 {
  color: #1a5f3f;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.PostAudio_breadcrumbLink__mUtw3:hover {
  color: #22543d;
  text-decoration: underline;
}

.PostAudio_breadcrumbSeparator__HVSmV {
  color: #94a3b8;
  margin: 0 4px;
}

.PostAudio_breadcrumbCurrent__0E7tw {
  color: #1e293b;
  font-weight: 600;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Category Badge - Audio Theme */
.PostAudio_categoryBadge__wPwno {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #1a5f3f 0%, #0d5f39 100%);
  color: white;
  padding: 10px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 30px;
  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3);
}

.PostAudio_categoryIcon__a3O0U img {
  width: 20px;
  height: 20px;
  filter: brightness(0) invert(1);
}

/* Post Header */
.PostAudio_postHeader__WZS8n {
  margin-bottom: 30px;
}

.PostAudio_postTitle__LhmKL {
  font-size: 32px;
  font-weight: 700;
  color: #1a202c;
  line-height: 1.3;
  margin: 0;
  background: linear-gradient(135deg, #1a5f3f 0%, #0d5e38 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Post Meta - Audio Theme */
.PostAudio_postMeta__ylQ2q {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 40px;
  padding: 20px;
  background: linear-gradient(135deg, #f8fffe 0%, #f0f9f7 100%);
  border-radius: 16px;
  border: 1px solid rgba(124, 58, 237, 0.1);
  flex-wrap: wrap;
}

.PostAudio_metaItem__Kt\\+UU {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #475569;
  font-size: 14px;
  font-weight: 500;
}

.PostAudio_metaIcon__sCGFI {
  font-size: 16px;
}

.PostAudio_metaText__XBReP {
  color: #334155;
}

.PostAudio_metaSeparator__uZLJ8 {
  color: #94a3b8;
  font-weight: bold;
}

/* Audio Media Section */
.PostAudio_mediaSection__9qGeZ {
  margin-bottom: 40px;
  text-align: center;
}

.PostAudio_audioContainer__s0Wkq {
  background: linear-gradient(135deg, #f8fffe 0%, #f0f9f7 100%);
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 8px 25px rgba(124, 58, 237, 0.1);
  border: 2px solid rgba(124, 58, 237, 0.1);

}

.PostAudio_audioPlayer__K3SRP {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  max-width: 500px;
  margin: 0 auto;
}

.PostAudio_audioThumbnail__4LlNs {
  width: 120px;
  height: 120px;
  background: linear-gradient(135deg, #1a5f3f 0%, #0c5e37 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(124, 58, 237, 0.3);
  position: relative;
  overflow: hidden;
}

.PostAudio_audioThumbnail__4LlNs::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at center, rgba(255,255,255,0.2) 0%, transparent 70%);
}

.PostAudio_audioIcon__CBToh {
  width: 60px;
  height: 60px;
  filter: brightness(0) invert(1);
  z-index: 1;
  position: relative;
}

.PostAudio_audioElement__G0RUb {
  width: 100%;
  height: 50px;
  border-radius: 25px;
  outline: none;
  background: white;
  box-shadow: 0 4px 15px rgba(124, 58, 237, 0.2);
}

.PostAudio_audioElement__G0RUb::-webkit-media-controls-panel {
  background-color: white;
  border-radius: 25px;
}

.PostAudio_mediaLoadingOverlay__NGJBw {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
}

.PostAudio_mediaLoadingSpinner__T3bk- {
  width: 40px;
  height: 40px;
  border: 3px solid #e2e8f0;
  border-top: 3px solid #1a5f3f;
  border-radius: 50%;
  animation: PostAudio_spin__keZie 1s linear infinite;
}

.PostAudio_defaultMediaContainer__igsQY {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  background: linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%);
  border-radius: 20px;
  border: 2px dashed #c084fc;
}

.PostAudio_defaultMediaIcon__Mjqq2 {
  width: 80%;
  height: 500px;
  /* opacity: 0.6;
  filter: brightness(0) saturate(100%) invert(37%) sepia(52%) saturate(5613%) hue-rotate(258deg) brightness(92%) contrast(94%); */
}

/* Post Content */
.PostAudio_postContent__pY0N8 {
  margin-bottom: 40px;
}

.PostAudio_contentHtml__eQK31,
.PostAudio_contentText__OCuAj {
  font-size: 18px;
  line-height: 1.8;
  color: #334155;
  text-align: justify;
}

.PostAudio_contentHtml__eQK31 h1,
.PostAudio_contentHtml__eQK31 h2,
.PostAudio_contentHtml__eQK31 h3 {
  color: #1a5f3f;
  margin-top: 2em;
  margin-bottom: 1em;
  margin-bottom: 10px;
}

.PostAudio_contentHtml__eQK31 p {
  margin-bottom: 1.5em;
}

.PostAudio_contentHtml__eQK31 a {
  color: #1a5f3f;
  text-decoration: none;
  font-weight: 600;
}

.PostAudio_contentHtml__eQK31 a:hover {
  text-decoration: underline;
}

/* Post Footer */
.PostAudio_postFooter__sfsOv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 30px;
  border-top: 2px solid #e2e8f0;
  flex-wrap: wrap;
  gap: 20px;
}

.PostAudio_postStatus__DYOI4 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
}

.PostAudio_statusIcon__zaflq {
  font-size: 16px;
}

.PostAudio_statusText__d8bJx {
  color: #16a34a;
}

.PostAudio_navigationActions__LGKaN {
  display: flex;
  gap: 16px;
}

.PostAudio_backToListButton__aIkrA {
  background: linear-gradient(135deg, #1a5f3f 0%, #0e7444 100%);
  color: white;
  text-decoration: none;
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3);
}

.PostAudio_backToListButton__aIkrA:hover {
  background: #22543d;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px #22543d;
}

/* Related Posts - Audio Theme */
.PostAudio_relatedPostsSection__Tk3W\\+ {
  background: linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 8px 32px rgba(124, 58, 237, 0.1);
  border: 1px solid rgba(124, 58, 237, 0.1);
}

.PostAudio_relatedPostsTitle__FHOTW {
  font-size: 24px;
  font-weight: 700;
  color: #1a5f3f;
  margin-bottom: 30px;
  text-align: center;
}

.PostAudio_relatedPostsGrid__kl5vw {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.PostAudio_relatedPostCard__qUmrO {
  display: block;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  text-decoration: none;
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.PostAudio_relatedPostCard__qUmrO:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 28px #22543d;
  border-color: #1a5f3f;
}

.PostAudio_relatedPostImage__9T2ow {
  height: 150px;
  overflow: hidden;
  background: linear-gradient(135deg, #1a5f3f 0%, #0c683d 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.PostAudio_relatedPostImage__9T2ow img {
  width: 60px;
  height: 60px;
  filter: brightness(0) invert(1);
  transition: transform 0.3s ease;
}

.PostAudio_relatedPostCard__qUmrO:hover .PostAudio_relatedPostImage__9T2ow img {
  transform: scale(1.1);
}

.PostAudio_relatedPostContent__xYTTD {
  padding: 20px;
}

.PostAudio_relatedPostTitle__TyrNm {
  font-size: 16px;
  font-weight: 600;
  color: #1a202c;
  margin: 0 0 8px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.PostAudio_relatedPostDate__iE7GA {
  font-size: 12px;
  color: #64748b;
  margin: 0;
}

/* Loading States */
.PostAudio_loadingContainer__ibRfI {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  background: linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%);
  border-radius: 20px;
  margin: 20px auto;
  max-width: 600px;
}

.PostAudio_loadingSpinner__lxHGA {
  width: 50px;
  height: 50px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #1a5f3f;
  border-radius: 50%;
  animation: PostAudio_spin__keZie 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes PostAudio_spin__keZie {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.PostAudio_loadingText__FA18S {
  color: #1a5f3f;
  font-size: 18px;
  font-weight: 600;
}

/* Error States */
.PostAudio_errorContainer__\\+RdPr,
.PostAudio_notFoundContainer__UCcva {
  text-align: center;
  padding: 60px 40px;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border-radius: 20px;
  margin: 20px auto;
  max-width: 600px;
  border: 1px solid #fca5a5;
}

.PostAudio_errorIcon__vuezg,
.PostAudio_notFoundIcon__Bpxch {
  font-size: 60px;
  margin-bottom: 20px;
}

.PostAudio_errorTitle__9yHTU,
.PostAudio_notFoundTitle__4SWj0 {
  font-size: 24px;
  font-weight: 700;
  color: #dc2626;
  margin-bottom: 16px;
}

.PostAudio_errorMessage__ZbzqG,
.PostAudio_notFoundMessage__2Cdae {
  font-size: 16px;
  color: #7f1d1d;
  margin-bottom: 30px;
  line-height: 1.6;
}

.PostAudio_errorActions__gfCAn {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.PostAudio_backButton__TRts8,
.PostAudio_retryButton__2gIOJ {
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

.PostAudio_backButton__TRts8 {
  background: #6b7280;
  color: white;
}

.PostAudio_backButton__TRts8:hover {
  background: #22543d;
  transform: translateY(-2px);
}

.PostAudio_retryButton__2gIOJ {
  background: #dc2626;
  color: white;
}

.PostAudio_retryButton__2gIOJ:hover {
  background: #22543d;
  transform: translateY(-2px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .PostAudio_postContainer__-H-t9 {
    padding: 15px;
  }

  .PostAudio_postWrapper__Mes9l,
  .PostAudio_relatedPostsSection__Tk3W\\+ {
    padding: 25px;
  }

  .PostAudio_postTitle__LhmKL {
    font-size: 24px;
  }

  .PostAudio_postMeta__ylQ2q {
    flex-direction: column;
    align-items: start;
    gap: 12px;
  }

  .PostAudio_postFooter__sfsOv {
    flex-direction: column;
    text-align: center;
  }

  .PostAudio_relatedPostsGrid__kl5vw {
    grid-template-columns: 1fr;
  }

  .PostAudio_audioThumbnail__4LlNs {
    width: 100px;
    height: 100px;
  }

  .PostAudio_audioIcon__CBToh {
    width: 50px;
    height: 50px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Posts pages/PostAudio.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,cAAc;EACd,6DAA6D;EAC7D,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,8CAA8C;EAC9C,yCAAyC;;AAE3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wFAAwF;AAC1F;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,mDAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,aAAa;EACb;iIAC+H;AACjI;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,gCAAgC;AAChC;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,8CAA8C;EAC9C,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6DAA6D;EAC7D,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,mDAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".postContainer {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  direction: rtl;\r\n  background: linear-gradient(135deg, #f8fffe 0%, #f0f9f7 100%);\r\n  min-height: fit-content;\r\n}\r\n\r\n.postWrapper {\r\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\r\n  border-radius: 20px;\r\n  padding: 40px;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\r\n  border: 1px solid #e2e8f0;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n/* Breadcrumb Navigation */\r\n.breadcrumb {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 30px;\r\n  font-size: 14px;\r\n  color: #64748b;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.breadcrumbLink {\r\n  color: #1a5f3f;\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n  transition: color 0.3s ease;\r\n}\r\n\r\n.breadcrumbLink:hover {\r\n  color: #22543d;\r\n  text-decoration: underline;\r\n}\r\n\r\n.breadcrumbSeparator {\r\n  color: #94a3b8;\r\n  margin: 0 4px;\r\n}\r\n\r\n.breadcrumbCurrent {\r\n  color: #1e293b;\r\n  font-weight: 600;\r\n  max-width: 200px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Category Badge - Audio Theme */\r\n.categoryBadge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #0d5f39 100%);\r\n  color: white;\r\n  padding: 10px 16px;\r\n  border-radius: 20px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  margin-bottom: 30px;\r\n  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3);\r\n}\r\n\r\n.categoryIcon img {\r\n  width: 20px;\r\n  height: 20px;\r\n  filter: brightness(0) invert(1);\r\n}\r\n\r\n/* Post Header */\r\n.postHeader {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.postTitle {\r\n  font-size: 32px;\r\n  font-weight: 700;\r\n  color: #1a202c;\r\n  line-height: 1.3;\r\n  margin: 0;\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #0d5e38 100%);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\n/* Post Meta - Audio Theme */\r\n.postMeta {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  margin-bottom: 40px;\r\n  padding: 20px;\r\n  background: linear-gradient(135deg, #f8fffe 0%, #f0f9f7 100%);\r\n  border-radius: 16px;\r\n  border: 1px solid rgba(124, 58, 237, 0.1);\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.metaItem {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  color: #475569;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n\r\n.metaIcon {\r\n  font-size: 16px;\r\n}\r\n\r\n.metaText {\r\n  color: #334155;\r\n}\r\n\r\n.metaSeparator {\r\n  color: #94a3b8;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Audio Media Section */\r\n.mediaSection {\r\n  margin-bottom: 40px;\r\n  text-align: center;\r\n}\r\n\r\n.audioContainer {\r\n  background: linear-gradient(135deg, #f8fffe 0%, #f0f9f7 100%);\r\n  border-radius: 20px;\r\n  padding: 30px;\r\n  box-shadow: 0 8px 25px rgba(124, 58, 237, 0.1);\r\n  border: 2px solid rgba(124, 58, 237, 0.1);\r\n\r\n}\r\n\r\n.audioPlayer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 20px;\r\n  max-width: 500px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.audioThumbnail {\r\n  width: 120px;\r\n  height: 120px;\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #0c5e37 100%);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  box-shadow: 0 8px 25px rgba(124, 58, 237, 0.3);\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.audioThumbnail::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: radial-gradient(circle at center, rgba(255,255,255,0.2) 0%, transparent 70%);\r\n}\r\n\r\n.audioIcon {\r\n  width: 60px;\r\n  height: 60px;\r\n  filter: brightness(0) invert(1);\r\n  z-index: 1;\r\n  position: relative;\r\n}\r\n\r\n.audioElement {\r\n  width: 100%;\r\n  height: 50px;\r\n  border-radius: 25px;\r\n  outline: none;\r\n  background: white;\r\n  box-shadow: 0 4px 15px rgba(124, 58, 237, 0.2);\r\n}\r\n\r\n.audioElement::-webkit-media-controls-panel {\r\n  background-color: white;\r\n  border-radius: 25px;\r\n}\r\n\r\n.mediaLoadingOverlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(255, 255, 255, 0.9);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 20px;\r\n}\r\n\r\n.mediaLoadingSpinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 3px solid #e2e8f0;\r\n  border-top: 3px solid #1a5f3f;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n.defaultMediaContainer {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 300px;\r\n  background: linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%);\r\n  border-radius: 20px;\r\n  border: 2px dashed #c084fc;\r\n}\r\n\r\n.defaultMediaIcon {\r\n  width: 80%;\r\n  height: 500px;\r\n  /* opacity: 0.6;\r\n  filter: brightness(0) saturate(100%) invert(37%) sepia(52%) saturate(5613%) hue-rotate(258deg) brightness(92%) contrast(94%); */\r\n}\r\n\r\n/* Post Content */\r\n.postContent {\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.contentHtml,\r\n.contentText {\r\n  font-size: 18px;\r\n  line-height: 1.8;\r\n  color: #334155;\r\n  text-align: justify;\r\n}\r\n\r\n.contentHtml h1,\r\n.contentHtml h2,\r\n.contentHtml h3 {\r\n  color: #1a5f3f;\r\n  margin-top: 2em;\r\n  margin-bottom: 1em;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.contentHtml p {\r\n  margin-bottom: 1.5em;\r\n}\r\n\r\n.contentHtml a {\r\n  color: #1a5f3f;\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n}\r\n\r\n.contentHtml a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Post Footer */\r\n.postFooter {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding-top: 30px;\r\n  border-top: 2px solid #e2e8f0;\r\n  flex-wrap: wrap;\r\n  gap: 20px;\r\n}\r\n\r\n.postStatus {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n.statusIcon {\r\n  font-size: 16px;\r\n}\r\n\r\n.statusText {\r\n  color: #16a34a;\r\n}\r\n\r\n.navigationActions {\r\n  display: flex;\r\n  gap: 16px;\r\n}\r\n\r\n.backToListButton {\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #0e7444 100%);\r\n  color: white;\r\n  text-decoration: none;\r\n  padding: 12px 24px;\r\n  border-radius: 12px;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3);\r\n}\r\n\r\n.backToListButton:hover {\r\n  background: #22543d;\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 16px #22543d;\r\n}\r\n\r\n/* Related Posts - Audio Theme */\r\n.relatedPostsSection {\r\n  background: linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%);\r\n  border-radius: 20px;\r\n  padding: 40px;\r\n  box-shadow: 0 8px 32px rgba(124, 58, 237, 0.1);\r\n  border: 1px solid rgba(124, 58, 237, 0.1);\r\n}\r\n\r\n.relatedPostsTitle {\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  color: #1a5f3f;\r\n  margin-bottom: 30px;\r\n  text-align: center;\r\n}\r\n\r\n.relatedPostsGrid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n  gap: 20px;\r\n}\r\n\r\n.relatedPostCard {\r\n  display: block;\r\n  background: white;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n  text-decoration: none;\r\n  transition: all 0.3s ease;\r\n  border: 1px solid #e2e8f0;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.relatedPostCard:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 12px 28px #22543d;\r\n  border-color: #1a5f3f;\r\n}\r\n\r\n.relatedPostImage {\r\n  height: 150px;\r\n  overflow: hidden;\r\n  background: linear-gradient(135deg, #1a5f3f 0%, #0c683d 100%);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.relatedPostImage img {\r\n  width: 60px;\r\n  height: 60px;\r\n  filter: brightness(0) invert(1);\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.relatedPostCard:hover .relatedPostImage img {\r\n  transform: scale(1.1);\r\n}\r\n\r\n.relatedPostContent {\r\n  padding: 20px;\r\n}\r\n\r\n.relatedPostTitle {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #1a202c;\r\n  margin: 0 0 8px 0;\r\n  line-height: 1.4;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n\r\n.relatedPostDate {\r\n  font-size: 12px;\r\n  color: #64748b;\r\n  margin: 0;\r\n}\r\n\r\n/* Loading States */\r\n.loadingContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 400px;\r\n  background: linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%);\r\n  border-radius: 20px;\r\n  margin: 20px auto;\r\n  max-width: 600px;\r\n}\r\n\r\n.loadingSpinner {\r\n  width: 50px;\r\n  height: 50px;\r\n  border: 4px solid #e2e8f0;\r\n  border-top: 4px solid #1a5f3f;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n.loadingText {\r\n  color: #1a5f3f;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Error States */\r\n.errorContainer,\r\n.notFoundContainer {\r\n  text-align: center;\r\n  padding: 60px 40px;\r\n  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);\r\n  border-radius: 20px;\r\n  margin: 20px auto;\r\n  max-width: 600px;\r\n  border: 1px solid #fca5a5;\r\n}\r\n\r\n.errorIcon,\r\n.notFoundIcon {\r\n  font-size: 60px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.errorTitle,\r\n.notFoundTitle {\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  color: #dc2626;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.errorMessage,\r\n.notFoundMessage {\r\n  font-size: 16px;\r\n  color: #7f1d1d;\r\n  margin-bottom: 30px;\r\n  line-height: 1.6;\r\n}\r\n\r\n.errorActions {\r\n  display: flex;\r\n  gap: 16px;\r\n  justify-content: center;\r\n}\r\n\r\n.backButton,\r\n.retryButton {\r\n  padding: 12px 24px;\r\n  border-radius: 12px;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  transition: all 0.3s ease;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n}\r\n\r\n.backButton {\r\n  background: #6b7280;\r\n  color: white;\r\n}\r\n\r\n.backButton:hover {\r\n  background: #22543d;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.retryButton {\r\n  background: #dc2626;\r\n  color: white;\r\n}\r\n\r\n.retryButton:hover {\r\n  background: #22543d;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .postContainer {\r\n    padding: 15px;\r\n  }\r\n\r\n  .postWrapper,\r\n  .relatedPostsSection {\r\n    padding: 25px;\r\n  }\r\n\r\n  .postTitle {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .postMeta {\r\n    flex-direction: column;\r\n    align-items: start;\r\n    gap: 12px;\r\n  }\r\n\r\n  .postFooter {\r\n    flex-direction: column;\r\n    text-align: center;\r\n  }\r\n\r\n  .relatedPostsGrid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .audioThumbnail {\r\n    width: 100px;\r\n    height: 100px;\r\n  }\r\n\r\n  .audioIcon {\r\n    width: 50px;\r\n    height: 50px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"postContainer": `PostAudio_postContainer__-H-t9`,
	"postWrapper": `PostAudio_postWrapper__Mes9l`,
	"breadcrumb": `PostAudio_breadcrumb__4FUEW`,
	"breadcrumbLink": `PostAudio_breadcrumbLink__mUtw3`,
	"breadcrumbSeparator": `PostAudio_breadcrumbSeparator__HVSmV`,
	"breadcrumbCurrent": `PostAudio_breadcrumbCurrent__0E7tw`,
	"categoryBadge": `PostAudio_categoryBadge__wPwno`,
	"categoryIcon": `PostAudio_categoryIcon__a3O0U`,
	"postHeader": `PostAudio_postHeader__WZS8n`,
	"postTitle": `PostAudio_postTitle__LhmKL`,
	"postMeta": `PostAudio_postMeta__ylQ2q`,
	"metaItem": `PostAudio_metaItem__Kt+UU`,
	"metaIcon": `PostAudio_metaIcon__sCGFI`,
	"metaText": `PostAudio_metaText__XBReP`,
	"metaSeparator": `PostAudio_metaSeparator__uZLJ8`,
	"mediaSection": `PostAudio_mediaSection__9qGeZ`,
	"audioContainer": `PostAudio_audioContainer__s0Wkq`,
	"audioPlayer": `PostAudio_audioPlayer__K3SRP`,
	"audioThumbnail": `PostAudio_audioThumbnail__4LlNs`,
	"audioIcon": `PostAudio_audioIcon__CBToh`,
	"audioElement": `PostAudio_audioElement__G0RUb`,
	"mediaLoadingOverlay": `PostAudio_mediaLoadingOverlay__NGJBw`,
	"mediaLoadingSpinner": `PostAudio_mediaLoadingSpinner__T3bk-`,
	"spin": `PostAudio_spin__keZie`,
	"defaultMediaContainer": `PostAudio_defaultMediaContainer__igsQY`,
	"defaultMediaIcon": `PostAudio_defaultMediaIcon__Mjqq2`,
	"postContent": `PostAudio_postContent__pY0N8`,
	"contentHtml": `PostAudio_contentHtml__eQK31`,
	"contentText": `PostAudio_contentText__OCuAj`,
	"postFooter": `PostAudio_postFooter__sfsOv`,
	"postStatus": `PostAudio_postStatus__DYOI4`,
	"statusIcon": `PostAudio_statusIcon__zaflq`,
	"statusText": `PostAudio_statusText__d8bJx`,
	"navigationActions": `PostAudio_navigationActions__LGKaN`,
	"backToListButton": `PostAudio_backToListButton__aIkrA`,
	"relatedPostsSection": `PostAudio_relatedPostsSection__Tk3W+`,
	"relatedPostsTitle": `PostAudio_relatedPostsTitle__FHOTW`,
	"relatedPostsGrid": `PostAudio_relatedPostsGrid__kl5vw`,
	"relatedPostCard": `PostAudio_relatedPostCard__qUmrO`,
	"relatedPostImage": `PostAudio_relatedPostImage__9T2ow`,
	"relatedPostContent": `PostAudio_relatedPostContent__xYTTD`,
	"relatedPostTitle": `PostAudio_relatedPostTitle__TyrNm`,
	"relatedPostDate": `PostAudio_relatedPostDate__iE7GA`,
	"loadingContainer": `PostAudio_loadingContainer__ibRfI`,
	"loadingSpinner": `PostAudio_loadingSpinner__lxHGA`,
	"loadingText": `PostAudio_loadingText__FA18S`,
	"errorContainer": `PostAudio_errorContainer__+RdPr`,
	"notFoundContainer": `PostAudio_notFoundContainer__UCcva`,
	"errorIcon": `PostAudio_errorIcon__vuezg`,
	"notFoundIcon": `PostAudio_notFoundIcon__Bpxch`,
	"errorTitle": `PostAudio_errorTitle__9yHTU`,
	"notFoundTitle": `PostAudio_notFoundTitle__4SWj0`,
	"errorMessage": `PostAudio_errorMessage__ZbzqG`,
	"notFoundMessage": `PostAudio_notFoundMessage__2Cdae`,
	"errorActions": `PostAudio_errorActions__gfCAn`,
	"backButton": `PostAudio_backButton__TRts8`,
	"retryButton": `PostAudio_retryButton__2gIOJ`
};
export default ___CSS_LOADER_EXPORT___;
